module.exports = __webpack_public_path__ + "static/media/t1.ff675a48.png";